<template>
  <button class="btn icon-dropdown-button" :class="invertStyle? 'inverted' : ''" type="button">
    <i :class="iconName" v-if="iconName"></i>
    <span class="title">{{ buttonText }}</span>
    <i class="dropdown-icon fas fa-caret-down text-right"></i>
  </button>
</template>

<script>
export default {
  name: "IconDropdownButton",
  props: [
    "buttonText",
    "iconName",
    "invertedStyle"
  ],
  computed: {
    invertStyle()
    {
      return this.invertedStyle;
    }
  },
  methods: {
    onClicked()
    {
      this.$emit("clicked");
    }
  }
}
</script>

<style lang="scss" scoped>
button
{
  display: flex;
  justify-content: flex-start;
  align-items: center;
  background-color: white;
  color: $font-dark;
  font-size: 1rem;
  font-weight: bold;

  height: 50px;
  border-radius: 5px;
  box-shadow: $default-shadow;

  &.inverted
  {
    background-color: $primary-blue;
    color: $font-light;

    .dropdown-icon
    {
      color: $font-light;
      transform: rotate(-90deg);
    }
  }

  i
  {
    margin-right: 0.5rem;
    flex-grow: 1;
    font-size: 1.3rem;
  }

  span
  {
    flex-grow: 6;
    text-align: left;
  }

  .dropdown-icon
  {
    color: $primary-blue;
  }
}
</style>